// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1Vzt_","form":"styles_form__f_0lg"};